import formStyles from "../form-styles/styles.css";
import { initComponent, cleanFieldValue } from "../../../utilities/common";

export const init = () => {
  initComponent("text-field", (element) => {
    const input = element.querySelector("input");
    const validationSpan = element.querySelector("[data-custom-message]");
    const maxLengthMessage = input.getAttribute("data-name-field-max-length");
    const requiredMessage = input.getAttribute("data-required-message");
    const isNameField =
      input && (input.name === "firstName" || input.name === "lastName");
    const hasMaxLength = input && input.hasAttribute("maxlength");
    const hasRequiredMessage =
      input && input.hasAttribute("data-required-message");
    const hasMaxLengthMessage =
      input && input.hasAttribute("data-name-field-max-length");
    const checkNameMaxLength =
      validationSpan &&
      isNameField &&
      hasMaxLength &&
      hasRequiredMessage &&
      hasMaxLengthMessage;
    const maxLength = checkNameMaxLength
      ? parseInt(input.getAttribute("maxlength"))
      : null;

    input.addEventListener("input", () => {
      input.value = cleanFieldValue(input.value);
      if (input.value.trim() === "") {
        input.value = "";
      }
    });

    input.addEventListener("keydown", (e) => {
      if (checkNameMaxLength) {
        const allowedKeys = [
          "Backspace",
          "Delete",
          "ArrowLeft",
          "ArrowRight",
          "ArrowUp",
          "ArrowDown",
          "Home",
          "End",
          "Tab"
        ];
        if (
          input.value.length >= maxLength - 2 &&
          !allowedKeys.includes(e.key) &&
          !e.ctrlKey && // Allow Ctrl+C, Ctrl+V, Ctrl+X, etc.
          !e.metaKey // Allow Cmd+C, Cmd+V, Cmd+X, etc. on Mac
        ) {
          showMaxLengthError(maxLengthMessage);
        }
      }
    });

    input.addEventListener("keyup", () => {
      if (checkNameMaxLength && input.value.length < maxLength - 2) {
        hideMaxLengthError();
      }
    });

    input.addEventListener("paste", (e) => {
      if (checkNameMaxLength) {
        let pasteData = e.clipboardData.getData("text");
        pasteData = cleanFieldValue(pasteData);
        if (pasteData.trim() === "") {
          pasteData = "";
        }
        const currentValue = input.value;
        const selectionStart = input.selectionStart;
        const selectionEnd = input.selectionEnd;

        // Calculate what the value would be after paste
        const newValue =
          currentValue.substring(0, selectionStart) +
          pasteData +
          currentValue.substring(selectionEnd);
        if (newValue.length >= maxLength - 2) {
          showMaxLengthError(maxLengthMessage);
        }
      }
    });

    input.addEventListener("blur", () => {
      input.value = input.value.trim();
      if (checkNameMaxLength) {
        hideMaxLengthError();
      }
    });

    function showMaxLengthError(message) {
      if (checkNameMaxLength) {
        validationSpan.innerText = message;
        input.classList.add(formStyles.invalid);
      }
    }

    function hideMaxLengthError() {
      if (checkNameMaxLength) {
        input.classList.remove(formStyles.invalid);
      }
    }

    element.resetToRequiredMessage = () => {
      if (checkNameMaxLength) {
        validationSpan.innerText = requiredMessage;
      }
    };

    element.getValues = () => {
      const value = input.value;
      return value && value !== "" ? [value] : [];
    };

    element.checkIsValid = () => {
      if (input.required) {
        return input.value.trim() !== "";
      }
      return true;
    };
  });
};
init();
